import React, { useState } from 'react';

export default function NotesEditor({ onSave }) {
  const [noteText, setNoteText] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    if (!noteText.trim()) return;

    setSaving(true);
    try {
      await onSave(noteText);  // ✅ trigger parent update
      setNoteText('');         // ✅ clear input
    } catch (err) {
      console.error('Failed to save note:', err);
    } finally {
      setSaving(false);
    }
  };

return (
  <div className="space-y-3">
    <textarea
      value={noteText}
      onChange={e => setNoteText(e.target.value)}
      placeholder="Add a note..."
      rows={4}
      className="
        w-full p-3 border border-[#D1D5DB] rounded-[12px]
        text-sm text-[#1F2937] focus:outline-none focus:ring-2 focus:ring-[#2563EB]
        placeholder-[#9CA3AF]
      "
    />

    <button
      onClick={handleSubmit}
      disabled={saving || !noteText.trim()}
      className={`
        w-full px-4 py-3 text-sm font-medium rounded-[12px] transition-colors duration-150
        ${saving || !noteText.trim()
          ? 'bg-[#9CA3AF] text-white cursor-not-allowed'
          : 'bg-[#2563EB] text-white hover:bg-[#1D4ED8]'
        }
      `}
    >
      {saving ? 'Saving…' : 'Save Note'}
    </button>
  </div>
);

}
